import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Field, Formik } from 'formik';
import { JwlField } from '../../../../components';
import * as Yup from 'yup';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import {
  GQLPieceInventory,
  GQLPieceInventoryUpdateInput
} from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorMessage } from '../../../../types-hack';
interface IProps {
  pieceInventory: GQLPieceInventory;
  onClose: (persisted: boolean) => void;
}

export const PieceInventoryUpdateDialog: React.FC<IProps> = ({ pieceInventory, onClose }) => {
  const initialValues = {
    inventoryReference: pieceInventory.inventoryReference
  };
  const [updatePieceInventory, { error, loading }] = GQLOperationBuilder.deliveryUnit.updatePieceInventory();

  const onSubmit = (values: any) => {
    const data: GQLPieceInventoryUpdateInput = {
      id: pieceInventory.id,
      inventoryReference: values.inventoryReference
    };

    const mutationVariables = {
      input: data
    };

    updatePieceInventory({
      variables: mutationVariables
    }).then(_result => {
      onClose(true);
    });
  };

  const onCancel = (_props: any) => {
    onClose(false);
  };

  const validationSchema = Yup.object().shape({
    inventoryReference: Yup.string().required('Inventory Reference is required')
  });
  return (
    <Dialog open={true} aria-labelledby="update-piece-inventory">
      <DialogTitle>Update Piece Inventory</DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ values, handleSubmit }) => (
            <form onSubmit={handleSubmit} className="flex flex-col">
              <Field name={`inventoryReference`} component={JwlField} label="Inventory Reference" />
              <ErrorMessage component="span" name={`inventoryReference`} className="fs-12 text-error" />

              <DialogActions>
                <Button color="primary" onClick={onCancel}>
                  Close
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  Save
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default PieceInventoryUpdateDialog;
